import React from "react";
import Productions from "../Productions";
import RolesState from "../../../api/RolesState";
import { NoRightsMessage } from "../../UI/NoRightsMessage";

export function CompanyCardSitesColumn({ getSoftProductionFunc }) {
  if (!RolesState.production_id) {
    return (
      <NoRightsMessage variant="panel">
        Нет прав для просмотра площадок
      </NoRightsMessage>
    );
  }
  return <Productions getSoftProductionFunc={getSoftProductionFunc} />;
}
